import React from 'react';
import { Link } from 'react-router-dom';
import { PipelineDiagram } from '../components/PipelineDiagram';
import { Triage } from '../components/Triage';
import { SeeIt } from '../components/SeeIt';
import { Faq } from '../components/Faq';
import { CtaBand } from '../components/CtaBand';
import { Ledger } from '../components/Ledger';
import { LibraryChart } from '../components/LibraryChart';
import { PAYOFF } from '../data/payoff';
export function Index() {
  return <>
      <header className="hero" data-id="element-562" data-mp="3vv7entle4wgx">
        <div className="hgrid" data-id="element-563" data-mp="3vw0dm8e3yhoi">
          <div className="col-l" data-id="element-564" data-mp="3vx1zl7wnwol0">
            <div className="lab-row" data-id="element-565" data-mp="dh7w8x596ev0">
              <span className="clabel" data-id="element-566" data-mp="di9hfufzghqg">The Instruction Layer</span>
            </div>
            <div className="head-block" data-id="element-567" data-mp="8q9ctooyx0nj">
              <h1 style={{
              fontSize: 'clamp(34px,4.35vw,54px)',
              lineHeight: 1.06,
              maxWidth: '21ch'
            }} data-id="element-568" data-mp="8p6p1pmxzebu">
                Your best judgment. Built into every answer that matters.
              </h1>
            </div>
            <div className="sub-block" data-id="element-569" data-mp="3c55b5qyahi33">
              <p className="sub" data-id="element-570" data-mp="1uxof6jh7qjtg">
                Synthia brings together what AI needs to honor &mdash; your policies and expertise, regulatory
                requirements, and industry guidance &mdash; and turns it into instruction data any model can act on{' '}
                <strong style={{
                color: 'var(--ink)'
              }} data-id="element-571" data-mp="24p2byjhs55iw">before it answers</strong>. What&rsquo;s binding goes first. A
                receipt proves what the model was told.
              </p>
              <p className="kicker" data-id="element-572" data-mp="1c0dgp13enuf2">Retrieval degrades gracefully. Obligations don&rsquo;t.</p>
              <div className="ctas" data-id="element-573" data-mp="1gz7zi31dhiz6">
                <a className="btn g" href="#see-it" data-id="element-574" data-mp="1lvowlmqjv7oe">
                  See it in action &darr;
                </a>
                <Link className="btn o" to="/contact" data-id="element-575" data-mp="1pyuzqlid8iqn">
                  Bring us a workflow
                </Link>
              </div>
            </div>
          </div>
          <div className="col-r" data-id="element-576" data-mp="31cp1dxgfrnmu">
            <PipelineDiagram data-id="element-577" data-mp="31bxjfpfrhof1" />
          </div>
        </div>
      </header>

      <div className="split" data-id="element-578" data-mp="127payt7uwtwa">
        <div className="sp-l" data-id="element-579" data-mp="126w0bh5s1k8v">
          <span className="clabel" data-id="element-580" data-mp="12abhcpj0h3cx">Who it's for</span>
          <h2 style={{
          maxWidth: 'none',
          fontSize: 'clamp(23px,2.75vw,34px)'
        }} data-id="element-581" data-mp="x82m1mio1p7n">
            When AI speaks for
            <br data-id="element-582" data-mp="1b7lvcin7r6lj" />
            your business, the answer
            <br data-id="element-583" data-mp="16a24mj9bx1cp" />
            becomes the record.
          </h2>
          <p className="lede" data-id="element-584" data-mp="16alk7tbibdnk">
            Ask it &ldquo;what&rsquo;s the capital of France?&rdquo; and there&rsquo;s nothing to record. Find
            &ldquo;Paris.&rdquo; Display &ldquo;Paris.&rdquo; But the moment your AI drafts the denial letter, answers
            the regulator, or approves the claim, the output stops describing your business and starts{' '}
            <strong data-id="element-585" data-mp="ni9jtc4eymg2">committing</strong> it.
          </p>
          <p className="lede" style={{
          marginTop: 14
        }} data-id="element-586" data-mp="3vz4dq238gwi0">
            And the costly moments are the unscripted ones&mdash;the one-off email no template covers, the reply to an
            auditor nobody drafted in advance. You can&rsquo;t prewrite every consequential moment. Synthia gives AI
            the instructions that moment requires.
          </p>
          <p className="kicker" data-id="element-587" data-mp="2baa2bjsmfrc3">
            Find and display need no governance.
            <br data-id="element-588" data-mp="1xidie313wnqs" />
            Decide and commit do.
          </p>
        </div>
        <div className="sp-r" data-id="element-589" data-mp="22fvrbtf4j2ys">
          <Triage data-id="element-590" data-mp="22gx2rz01xrh1" />
        </div>
      </div>

      <div className="statband" data-id="element-591" data-mp="2q5zrtrx0mmlk">
        <div data-id="element-592" data-mp="2q716e6d8pr81">
          <div className="bignum" data-id="element-593" data-mp="2q7awdtyabydq">68%</div>
          <div className="bignum-lab" data-id="element-594" data-mp="2u7l1z5i60ms2">Adherence at high density</div>
        </div>
        <div data-id="element-595" data-mp="2u5gz8qw05ttd">
          <h2 data-id="element-596" data-mp="2g7sfjmdo8spw">
            68% adherence isn&rsquo;t a benchmark. <span data-id="element-597" data-mp="2g70jkag5wsz3">It&rsquo;s a liability.</span>
          </h2>
          <p className="lede" data-id="element-598" data-mp="2l6mzirndknbl">
            At high instruction density, even the best AI model tested missed nearly one in three instructions.
            <span style={{
            color: '#C2543C',
            fontWeight: 700,
            fontSize: '1.4em',
            lineHeight: 0,
            verticalAlign: '-0.14em'
          }} data-id="element-599" data-mp="14r25fs64ngr0">
              *
            </span>{' '}
            In business, the missing obligation could be a style preference &mdash; or the disclosure that keeps you
            compliant.
          </p>
          <p className="fnote" data-id="element-600" data-mp="1b9yk8no3rxef">
            <span style={{
            color: '#C2543C'
          }} data-id="element-601" data-mp="1barj72gtlim0">*</span>{' '}
            <a href="https://arxiv.org/abs/2507.11538" target="_blank" rel="noopener noreferrer" data-id="element-602" data-mp="2808v3z6ec0w5">
              IFScale, &ldquo;How Many Instructions Can LLMs Follow at Once?&rdquo;
            </a>{' '}
            At high density, the best-performing frontier model achieved 68% accuracy.
          </p>
        </div>
      </div>

      <div className="split split-seeit" id="see-it" data-id="element-603" data-mp="1u0zif9hefowx">
        <div className="sp-l" data-id="element-604" data-mp="1u2k8omwokloz">
          <span className="clabel" data-id="element-605" data-mp="nk43hv0nxoow">See it</span>
          <h2 data-id="element-606" data-mp="nlyrxjb57yxq">
            Eleven words.
            <br data-id="element-607" data-mp="ilkj3z1pwkyn" />
            <span className="g" data-id="element-608" data-mp="ikri7epfwpof">Years of judgment.</span>
          </h2>
          <p className="lede" style={{
          maxWidth: '50ch'
        }} data-id="element-609" data-mp="8hdwd24kxr4r">
            A simple request carries more than it says. Hover over the underlined words to discover the expertise and
            obligations behind the answer &mdash; Synthia seats them along with the prompt{' '}
            <strong data-id="element-610" data-mp="ie8tphp49lhg">before the model&nbsp;answers</strong>.
          </p>
        </div>
        <div className="sp-r" data-id="element-611" data-mp="n7tiqk8qf54i">
          <SeeIt data-id="element-612" data-mp="n83c8hszjuey" />
        </div>
      </div>

      <div className="stoprow" data-id="element-613" data-mp="r6ty1ss03pmr">
        <div data-id="element-614" data-mp="r7lvl955rxfo">
          <span className="clabel" data-id="element-615" data-mp="ra80t24ku0uq">The payoff</span>
          <h2 style={{
          marginTop: 18
        }} data-id="element-616" data-mp="w5x5tkzd89yf">What changes.</h2>
        </div>
      </div>

      <div className="grid4" data-id="element-617" data-mp="115i0hj7i5w5c">
        {PAYOFF.map(p => <div className="cell" key={p.n} data-id="element-618" data-mp="1146zts9ct4ig">
            <span className="gnum" aria-hidden="true" data-id="element-619" data-mp="165e95vr5abr8">
              {p.n}
            </span>
            <div className="lab" data-id="element-620" data-mp="32y69yaaqpftk">
              <span data-id="element-621" data-mp="32yz9orba7527">{p.lab}</span>
            </div>
            <h3 data-id="element-622" data-mp="37w7w543gpv99">{p.title}</h3>
            <p data-id="element-623" data-mp="37xaicypub9iu">{p.body}</p>
          </div>)}
      </div>

      <div className="quoteband" data-id="element-624" data-mp="2zvjmqjklft4p">
        <p data-id="element-625" data-mp="2zwl04up30rpl">
          Models will misbehave in ways nobody has named yet.
          <br data-id="element-626" data-mp="2ux8c46mh5elf" />
          When one does, the first question is always the same:
          <br data-id="element-627" data-mp="39tzd2kbsqyd5" />
          <span className="q" data-id="element-628" data-mp="39uinzh314mho">what was it told?</span>
        </p>
      </div>

      <section className="keep" data-id="element-629" data-mp="34uw9737jyy6r">
        <div className="keep-grid" data-id="element-630" data-mp="34umre2wnvxc5">
          <div className="keep-copy" data-id="element-631" data-mp="34tl6z7tr9yhr">
            <span className="clabel" data-id="element-632" data-mp="3iue480bfz7ok">What you keep</span>
            <h2 data-id="element-633" data-mp="3isuny9pscwms">
              Your most valuable AI asset
              <br data-id="element-634" data-mp="3dwcj79uggyag" />
              <span className="g" data-id="element-635" data-mp="3dut4vosd0xbb">is already yours.</span>
            </h2>
            <p className="lede" data-id="element-636" data-mp="3skqlnjnymkqh">
              It&rsquo;s the judgment your company has built through years of doing the work. Knowing what matters.
              Recognizing the exception. Understanding what a policy means when a customer is waiting for an answer.
            </p>
            <p className="lede" data-id="element-637" data-mp="1efse9p6yo9p">
              Synthia turns that expertise into <strong data-id="element-638" data-mp="1c30b3ppyxix">a library of instruction data</strong> you own and can keep
              improving.
            </p>
            <p className="kicker" data-id="element-639" data-mp="p1knkyty34ae">
              The models will change.
              <br data-id="element-640" data-mp="ozgnyt32wrfx" />
              The value you build is yours.
            </p>
            <p style={{
            marginTop: 22
          }} data-id="element-641" data-mp="b19xhy0gltqa">
              <Link className="il" to="/how" data-id="element-642" data-mp="g0uva53w7w1f">
                See how it works →
              </Link>
            </p>
          </div>
          <div className="keep-art" data-id="element-643" data-mp="1bqb4idjfhqo">
            <div data-id="element-644" data-mp="1anownr5u3h3">
              <LibraryChart data-id="element-645" data-mp="1a5i4x6vg6ux" />
            </div>
          </div>
        </div>
      </section>

      <div className="stoprow" data-id="element-646" data-mp="64rt4z91jxeh">
        <h2 style={{
        maxWidth: 'none'
      }} data-id="element-647" data-mp="3oh7w27bck7zo">FAQs</h2>
      </div>

      <Faq data-id="element-648" data-mp="3oelfji6hai5b" />

      <CtaBand data-id="element-649" data-mp="3si9lxxjdj7oz" />
      <Ledger data-id="element-650" data-mp="3si03qw4km4tu" />
    </>;
}